//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { Button, IconButton, Modal, TextField } from '@mui/material';
import { Snackbar} from '@mui/material';
import { Add, Close, Delete, Edit } from '@mui/icons-material';
import { Alert } from '@mui/material';
//  -- Components ---------------------
import { Col, Input, Row, Space } from 'antd';
import { DeleteModal } from 'components/Dialog';
import Loading from "components/Loading";
import Section from 'components/Section';
import { filter, get, map } from "lodash";
import React, { useEffect, useMemo, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useBookOrder } from 'store/books/selectors';
import { handleUpdateListBookOrder } from 'store/books/thunks';
import styled from 'styled-components';
import { groupBookByOrder } from '../../utils/lib/ebookHelper';
import OrderBookGroup, { BookSignleList } from './orderBookGroup';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { captureException } from '@sentry/react';
const { Search } = Input;
//  -- Features -----------------------



//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------


export const Wrapper = styled.div`
    height: 100%;
    width: 100%;
`;
const LinkArea = styled.div`
  padding: 10px;
  margin: 2px;
  border: 1px dashed;
  margin-top: 24px;
`;

const ModalContent = styled.div`
  left: 50%;
  width: 70vw;
  padding: 0px 24px;
  position: absolute;
//   height:10vh;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px;
`;
const ModalConfigArea = styled.div`
  max-height: 75vh;
  overflow: auto;
  margin-top: 10px;
`;

const BookSection = styled.div`
    border: 2px solid #e9e9e9;
    box-shadow: ${(p) => p.active ? p.preActive ? "-3px 2px 8px 0px #9d0001, 3px 1px 5px #9d0000;" : " -3px 2px 8px 0px #00989d, 3px 1px 5px #00989d;" : ""};
    margin-bottom: 26px;
    position: relative;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 28px;
    width: auto;
    margin-right: 16px;
    padding-bottom: 16px;
    
`;

const SectionTitle = styled.div`
    font-size: 14px;
    color: #ffffff;
    background: ${p => p.bgColor ? p.bgColor : '#00c4cc'};
    padding: 4px 8px;
    border-radius: 6px !important;
    cursor: pointer;

    position: absolute;
    top: 8px;
    left: 8px;
    z-index: 99;
`;
const TitleText = styled.span`
    font-size: 18px;
    color: black;
    font-weight:600;
`;

//  ----------------------------------------------------------------------------
//  Container
//  ----------------------------------------------------------------------------
//
//  Not found container
//
//  -- Description
//  Failed route catch container
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  ...
//

const BookGrouping = ({ open, close, data, booksAllList, onCreateOrUpdate = () => { }, loading, orderedBook }) => {
    const [examTitle, setExamTitle] = useState('');
    const [isDisabled, setIsDisabled] = useState(false)
    const [error, setError] = useState(false);
    const order = data?.books.map(obj => obj.id)
    const [selectedBookOrder, setSelectedBookOrder] = useState([]);
    const bookOrders = selectedBookOrder.length > 0 ? selectedBookOrder : order;
    const [searchText, setSearchText] = useState("");
    const showAlert = useAlert();


    const onValidate = async () => {
        try{
            if (examTitle) {
                if (bookOrders && bookOrders.length > 0) {
                    setError(false);
                    await onCreateOrUpdate(examTitle, bookOrders);
                    // setExamTitle("");
                    setSelectedBookOrder([]);
                } else {
                    showAlert("Please Select Books", "error");
                }
            } else {
                showAlert("Please Enter Group Name and Select Books", "error");
            }
        }catch(error){
            captureException(error);
        }
    };
    useEffect(() => {
        setExamTitle(get(data, 'title'))
    }, [data])
    // const isDisabled = !get(examData, "src") || !get(examData, "displayName") || !get(examData, "bookId")
    return (
        <Modal
            open={open}
            onClose={() => {
                setSelectedBookOrder([])
                setError(false)
                close()
            }}
            style={{ height: '100%', width: '100%' }}
        >
            <ModalContent>
                <Row style={{ justifyContent: "space-between" }}>
                    <TitleText>{data ? 'Update Book Grouping' : 'Add Book Grouping'}</TitleText>
                    <IconButton onClick={() => {
                        setSelectedBookOrder([])
                        setError(false)
                        close()
                    }} style={{ padding: 0, marginRight: 10 }}>
                        <Close color="secondary" />
                    </IconButton>
                </Row>
                <ModalConfigArea>
                    <Row>
                    <div className='mt-10px flex items-center justify-between w-full gap-10px sm2-flex-wrap'>
                                <TextField
                                    id="displayName"
                                    name="displayName"
                                    label="Group name"
                                    required={false}
                                    type="text"
                                    variant="outlined"
                                    onChange={e => {
                                        setExamTitle(e.target.value)
                                    }}
                                    value={examTitle}
                                    sx={{
                                        '& .MuiOutlinedInput-root': {
                                            height: 40,
                                        },
                                    }}
                                />
                           <Space.Compact className='w-full'>
                                <Search  
                                    style={{ height: 40 }}
                                    rootClassName='grouping-root'
                                    className='search-grouping'  
                                    placeholder="input search text" 
                                    allowClear 
                                    value={searchText} 
                                    onChange={(e)=>setSearchText(e.target.value)}
                                />
                            </Space.Compact>
                            </div>
                         
                     
                        <BookSignleList data={filter(booksAllList,k=>k.img&&k.description&&k.pages.length)} selected={order ? order : []} orderedBook={orderedBook} onSelect={(item) => {
                            if (item.length > 0) {
                                setIsDisabled(false)
                                setSelectedBookOrder(item)
                            } else {
                                setIsDisabled(true)
                                setSelectedBookOrder([])
                            }
                        }} searchText={searchText} />
                    </Row>
                </ModalConfigArea>
                <Row gutter={[24, 24]} style={{ marginTop: 10, marginRight: 0, marginLeft: 0 }}>
                        <Button fullWidth
                            onClick={() => {
                                onValidate()
                            }}
                            disabled={isDisabled}
                            variant="contained" color="primary">
                            {loading ? <Loading white size={15} /> : null}
                            {data ? "Update" : "Create"}
                        </Button>
                    </Row>
            </ModalContent>
        </Modal>
    );
};
const mapOrder = (order=[]) => {
    return order.map(k => ({
       key:k.key,
       title:k.title,
       color:k.color,
       order:k.order
    }))
}

const AssessmentContainer = ({
    currentUser,
    booksAllList,
}) => {
    const dispatch = useDispatch()
    const [loadingModal, setLoadingModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const bookOrder = useBookOrder()
    const [activeIndex, setActiveIndex] = useState();
    const [selectedExam, setSelectedExam] = useState();
    const [openEditExamModal, setOpenEditExamModal] = React.useState(false);
    const [deleteLodaing, setDeleteLoading] = useState(false)
    const [openDeleteExamModal, setOpenDeleteExamModal] = React.useState(false);
    const [allBookOrder, setAllBookOrder] = useState(bookOrder);
    const orderedBook = useMemo(()=>groupBookByOrder(booksAllList, allBookOrder),[booksAllList,allBookOrder]);
    const [state, setState] = React.useState({
        open: false,
        message: ""
    });
    useEffect(()=>{
        setAllBookOrder(bookOrder)
    },[bookOrder])
    const handleClose = () => {
        setState({ open: false, message: "" });
    };
    const onEditGroup = (grpData, index) => {
        setSelectedExam(grpData)
        setActiveIndex(index)
        setOpenEditExamModal(true)
    }
    const onClose = () => {
        setOpenEditExamModal(false)
        setSelectedExam(null)
        setActiveIndex(null)
    }
    const onDeleteExam = async () => {
        const updatedBookOrder = [...allBookOrder];
        updatedBookOrder.splice(activeIndex, 1);
        setDeleteLoading(true)
        const updateList = await dispatch(handleUpdateListBookOrder(mapOrder(updatedBookOrder)))
        setActiveIndex(null)
        setSelectedExam(null)
        setDeleteLoading(false)
        setOpenDeleteExamModal(false)
        setAllBookOrder(updateList)
    }
    const { open, message } = state;

    const onSubmit = async (examTitle, bookOrders) => {
        if (selectedExam) {
            const updateData = {
               ...selectedExam,
                order: bookOrders,
                title: examTitle
            }

            allBookOrder[activeIndex] = updateData;
            setLoadingModal(true)
            const book_order = allBookOrder.map((k, i) => {
                if (!k.key) {
                   return{
                    ...k,
                    key: `bk_${k.title.replace(/\s/g, '_')}_${i}`
                   }
                }
                return k;
            })
            const updateList = await dispatch(handleUpdateListBookOrder(mapOrder(book_order)))

            setAllBookOrder(updateList)
            setSelectedExam(null)
            setLoadingModal(false)
            onClose()
        } else {
            const updateData = {
                color: 'rgb(53,90,92)',
                order: bookOrders,
                title: examTitle
            }
            let dummyOrder = allBookOrder;
            dummyOrder = [...dummyOrder, updateData]
            setLoadingModal(true)
            dummyOrder = dummyOrder.map((k, i) => {
                if (!k.key) {
                   return{
                    ...k,
                    key: `bk_${k.title.replace(/\s/g, '_')}_${i}`
                   }
                }
                return k;
            })
            const updateList = await dispatch(handleUpdateListBookOrder(mapOrder(dummyOrder)))

            setAllBookOrder(updateList)
            setLoadingModal(false)
            onClose()
            // console.log('create', updateData);
        }
    }
    const onRearrangedBookOrder = async (index, orderbook) => {
        let newOrd = [...bookOrder];
        const ord = orderbook.map(k => k.id)
        if (!newOrd || !newOrd[index]) return;
        newOrd[index].order = ord;
        setLoadingModal(true)
         newOrd = newOrd.map((k, i) => {
                if (!k.key) {
                   return{
                    ...k,
                    key: `bk_${k.title.replace(/\s/g, '_')}_${i}`
                   }
                }
                return k;
            })
        const updateList = await dispatch(handleUpdateListBookOrder(mapOrder(newOrd)))
        setAllBookOrder(updateList)
        setLoadingModal(false)
    }
    return (
        <Wrapper>
            {loading ? (
                <Loading />
            ) : (<>
                <Snackbar
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                    open={open}
                    autoHideDuration={3000}
                    onClose={handleClose}>
                    <Alert onClose={handleClose} severity="error">
                        <strong>ALERT:</strong> {message}
                    </Alert>
                </Snackbar>
                <DeleteModal
                    deleteToggle={openDeleteExamModal}
                    onDelete={onDeleteExam}
                    message={`Are you sure you want to delete ${get(selectedExam, "title", "this Exam")}?`}
                    setDeleteToggle={() => {
                        setOpenDeleteExamModal(false)
                    }} loading={deleteLodaing} />
                <BookGrouping
                    open={openEditExamModal}
                    close={onClose}
                    data={selectedExam}
                    bookOrder={bookOrder}
                    activeIndex={activeIndex}
                    orderedBook={orderedBook}
                    // exam={activeExamData}
                    loading={loadingModal}
                    booksAllList={booksAllList}
                    // redirectToBook={redirectToBook}
                    onCreateOrUpdate={(examTitle, bookOrders) => {
                        if (examTitle && bookOrders && bookOrders.length > 0) {
                            onSubmit(examTitle, bookOrders)
                        } else {
                            console.log('error')
                        }
                    }}
                />
                <Row gutter={[24, 24]} style={{ marginTop: 10, marginRight: 0, marginLeft: 0, marginBottom: 30 }}>
                    <Button onClick={() => {
                        setActiveIndex(null)
                        setOpenEditExamModal(true)
                    }} color='primary' variant="contained" >
                        <Add /> Add Book Grouping
                    </Button>
                </Row>
                <Row style={{ marginTop: '1%' }}>
                    <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                        <Section style={{ fontSize: '18px' }}
                            description="Resources books"
                            header='Resources'>
                            {map(orderedBook, (books, index) => {
                                return (
                                    <LinkArea>
                                        <Row>
                                            <Col span={24}>
                                                <Button onClick={() => {
                                                    onEditGroup(books, index)
                                                }} color='primary' variant="contained" >
                                                    <Edit style={{ fontSize: 20, marginRight: 3 }} /> EDIT
                                                </Button>
                                                <Button
                                                    onClick={() => {
                                                        setOpenDeleteExamModal(true)
                                                        setSelectedExam(books);
                                                        setActiveIndex(index);
                                                    }}
                                                    color="secondary"
                                                    variant="contained"
                                                    style={{ marginLeft: '10px' }}
                                                >
                                                    <Delete style={{ fontSize: 20, marginRight: 3 }} /> Delete
                                                </Button>
                                            </Col>
                                        </Row>
                                        <Row style={{ marginTop: '10px', marginLeft: 20 }}>
                                            <Col xs={{ span: 24 }} lg={{ span: 24 }}>
                                                <BookSection>
                                                    <SectionTitle bgColor={books.color} >{books.title}</SectionTitle>
                                                    <OrderBookGroup chapter={books?.books} onRearrangeDone={(orderbook)=>onRearrangedBookOrder(index,orderbook)} />
                                                </BookSection>
                                            </Col>
                                        </Row>
                                    </LinkArea>
                                )
                            })}
                        </Section>
                    </Col>
                </Row>
            </>)}

        </Wrapper>
    );
};



//  ----------------------------------------------------------------------------
//  ----------------------------------------------------------------------------
//  Redux
//  ----------------------------------------------------------------------------
const mapStateToProps = state => ({
    currentUser: state.currentUser,
    classActivities: state.classActivities,
    classQuizzes: state.classQuizzes,
    booksAllList: state.booksAllList
});

export default connect(mapStateToProps, null)(AssessmentContainer);
